import { TrainFill24Icon } from "@vygruppen/spor-icon-react";
import {
  PlanEventInformation,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { useHeaderCount } from "features/CenterContent/RoleContent/EventHandling/useHeaderCount";
import { FC } from "react";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import { Flex, HStack, Text, tokens } from "shared/components/Spor";
import { InfrastructureIncidentIcon24 } from "shared/icons/InfrastructureIncidentIcon24";
import { useTheme } from "styled-components";

type EventStateHeaderProps = {
  state: PlanMeasureKey;
  infraMeasures: PlanEventInformation[] | undefined;
  trainMeasures: PlanEventInformation[] | undefined;
  showClosedInfraMeasures: boolean;
  showClosedTrainMeasures: boolean;
};

const STATE_LABELS = {
  noCoverage: "Hendelser uten tiltak",
  unpublished: "Upubliserte tiltak",
  published: "Publiserte tiltak",
  withdrawn: "Tilbaketrukne tiltak",
};

export const EventStateHeader: FC<EventStateHeaderProps> = ({
  state,
  infraMeasures,
  trainMeasures,
  showClosedInfraMeasures,
  showClosedTrainMeasures,
}) => {
  const theme = useTheme();

  const {
    count: infraCount,
    notifying: infraNotifying,
    notifyingOrChangedCount: infraNotifyingOrChangedCount,
  } = useHeaderCount(
    infraMeasures,
    showClosedInfraMeasures,
    state === "noCoverage",
  );

  const {
    count: trainCount,
    notifying: trainNotifying,
    notifyingOrChangedCount: trainNotifyingOrChangedCount,
  } = useHeaderCount(
    trainMeasures,
    showClosedTrainMeasures,
    state === "noCoverage",
  );

  return (
    <Flex
      backgroundColor={theme.colorBackgroundSecondary}
      borderRadius={tokens.default.size.spacing[1]}
      flexDirection="row"
      alignItems="center"
      width="100%"
      overflow="hidden"
    >
      <Text
        variant="md"
        fontWeight="bold"
        p={tokens.default.size.spacing[2]}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {`${STATE_LABELS[state]} (${infraCount + trainCount})`}
      </Text>
      <HStack ml="auto" mr={tokens.default.size.spacing[1.5]} align="right">
        {infraNotifyingOrChangedCount > 0 && (
          <HStack gap={tokens.default.size.spacing[0.5]}>
            <InfrastructureIncidentIcon24 />
            <AlertsCounter
              alerts={infraNotifyingOrChangedCount}
              semantics={infraNotifying ? "alarm" : "warning"}
            />
          </HStack>
        )}
        {trainNotifyingOrChangedCount > 0 && (
          <HStack gap={tokens.default.size.spacing[0.5]}>
            <TrainFill24Icon />
            <AlertsCounter
              alerts={trainNotifyingOrChangedCount}
              semantics={trainNotifying ? "alarm" : "warning"}
            />
          </HStack>
        )}
      </HStack>
    </Flex>
  );
};
